var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-box"},[_c('div',[_c('div',{style:({ height: _vm.height || '400px' }),attrs:{"id":_vm.containerId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }